module.exports = __webpack_public_path__ + "img/card3.d88aa859.png";